import { z } from "zod";

export * from "./storage";
export * from "./fixtures";
export * from "./attachments";
export * from "./attachment-fixtures";
export * from "./snapshot-manifest";
export * from "./trello-capture";
export * from "./portable-snapshot";
export * from "./portable-writers";
export * from "./manifest-builder";
export * from "./portable-archive";
export * from "./uploaded-restore-archive";
export * from "./cloud-preserve";
export * from "./cloud-schedule";
export * from "./snapshot-compare";
export * from "./restore-plan";
export * from "./restore-source";
export * from "./in-place-restore";

export const environmentSchema = z.enum(["local", "devstage", "production"]);
export type Environment = z.infer<typeof environmentSchema>;

export const snapshotStatusSchema = z.enum([
  "pending",
  "capturing_structure",
  "capturing_attachments",
  "building_archive",
  "complete",
  "complete_with_warnings",
  "failed",
]);
export type SnapshotStatus = z.infer<typeof snapshotStatusSchema>;

export const jobTypeSchema = z.enum([
  "capture",
  "attachment",
  "export",
  "restore",
]);
export type JobType = z.infer<typeof jobTypeSchema>;

const jobMessageBaseSchema = z.object({
  accountId: z.uuid(),
  boardId: z.string().min(1),
  jobId: z.uuid(),
  requestedAt: z.iso.datetime(),
  snapshotId: z.uuid(),
});

export const jobMessageSchema = z.discriminatedUnion("jobType", [
  jobMessageBaseSchema.extend({ jobType: z.literal("capture") }),
  jobMessageBaseSchema.extend({
    attachmentId: z.string().min(1),
    jobType: z.literal("attachment"),
  }),
  jobMessageBaseSchema.extend({ jobType: z.literal("export") }),
  jobMessageBaseSchema.extend({ jobType: z.literal("restore") }),
]);
export type JobMessage = z.infer<typeof jobMessageSchema>;

export const uploadedRestoreValidationMessageSchema = z.object({
  importId: z.uuid(),
  jobType: z.literal("uploaded_restore_validation"),
  requestedAt: z.iso.datetime(),
});
export type UploadedRestoreValidationMessage = z.infer<
  typeof uploadedRestoreValidationMessageSchema
>;

export const queueMessageSchema = z.union([
  jobMessageSchema,
  uploadedRestoreValidationMessageSchema,
]);
export type QueueMessage = z.infer<typeof queueMessageSchema>;

export const healthResponseSchema = z.object({
  environment: environmentSchema,
  requestId: z.uuid(),
  service: z.literal("board-preserve-api"),
  status: z.literal("ok"),
});
export type HealthResponse = z.infer<typeof healthResponseSchema>;
